import { Injectable, Input } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { endpoints } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import CryptoJS from 'crypto-js';
import * as $ from 'jquery';


@Injectable()
export class ThemeService {
	public currentURL = '';

	private defaultThemeConfigs = {
		isDefault: true,
		isOpenBank : true,
		isAttendant : false,
		NomeParceiro : 'Omni Banco',
		CorPrimaria : '#013188',
		CorSecundaria : '#FF720A',
		Logo : '', // base64
		TermosUso : '',
		CorTextoBotao : '#FFFFFF',
		CorBotaoDesabilitado : '#C2C2C2',
		CorTextoBotaoDesabilitado : '#3C3C3C',
		Imagens : [
			{
				TipoImagem : '',
				ConteudoImagem : '',
				Height : 0,
				Width : 0,
			},
		],
		Menus: {
			inicio: true,
			sair: true,
			cartao: true,
			cobranca: true,
			transacao: true,
			deposito: true,
			transferencia: true,
			pagamento: true,
			pix: true,
			extrato: true,
			comprovante: true,
			limite: true,
			investimento: true,
			minhaConta: true,
			outrasContas: true,
			token: true,
		},
		FraseInicial1 : '',
		FraseInicial2 : '',
		CorFrase1 : '',
		CorFrase2 : '',
	};

	private _idsAPI = [
		{
			'parceiro': 'vidapay',
			'prod' : {
				'url': 'www.vidapay.com.vc',
				'identificador': 'c81e728d9d4c2f636f067f89cc14862c',
			},
			'hmg' : {
				'url': 'hmg-vidapay.omni.com.br',
				'identificador': '1ff1de774005f8da13f42943881c655f',
			}
		},
		{
			'parceiro': 'Rede Uze',
			'prod' : {
				'url': 'www.uzeconta.com.br',
				'identificador': '1679091c5a880faf6fb5e6087eb1b2dc',
			},
			'hmg' : {
				'url': 'hmg-rede-uze.omni.com.br',
				'identificador': 'a87ff679a2f3e71d9181a67b7542122c',
			}
		},
		{
			'parceiro': 'Pulo do Gato',
			'prod' : {
				'url': 'prd-pulo-do-gato.omni.com.br',
				'identificador': 'a87ff679a2f3e71d9181a67b7542122c',
			},
			'hmg' : {
				'url': '',
				'identificador': '',
			}
		},
		{
			'parceiro': 'engehall',
			'prod' : {
				'url': 'www.powerclub.com.br',
				'identificador': 'eccbc87e4b5ce2fe28308fd9f2a7baf3',
			},
			'hmg' : {
				'url': '',
				'identificador': '',
			}
		},
		{
			'parceiro': 'Omni sem fronteira',
			'prod' : {
				'url': 'prd-omni-sem-fronteira.omni.com.br',
				'identificador': 'e4da3b7fbbce2345d7772b0674a318d5',
			},
			'hmg' : {
				'url': '',
				'identificador': '',
			}
		}
	];

	private _themeConfigs: any;


	constructor(
		private http: HttpClient
		) {
			this.defaultThemeConfigs.isAttendant = (this.getIdWhiteLabel() === '9b8619251a19057cff70779273e95aa6') ? true : false;
		}

		getIdWhiteLabel = () => {
			let ident;

			this._idsAPI.map(parceiro => {
				const currentURL =  window.location.href.replace(/(^\w+:|^)\/\//, '').split('/')[0];
				this.currentURL = currentURL;

				if (parceiro.prod.url === currentURL) {
					ident = parceiro.prod.identificador;
				} else if (parceiro.hmg.url === currentURL) {
					ident = parceiro.hmg.identificador;
				}

			});

			return ident;
		}

		get themeConfigs() {
			return this._themeConfigs;
		}


		get nomeParceiro() {
			return this._themeConfigs.NomeParceiro;
		}

		get FraseInicial1() {
			return this._themeConfigs.FraseInicial1;
		}

		get FraseInicial2() {
			return this._themeConfigs.FraseInicial2;
		}

		get CorBotaoDesabilitado() {
			return this._themeConfigs.CorBotaoDesabilitado;
		}

		get CorTextoBotaoDesabilitado() {
			return this._themeConfigs.CorTextoBotaoDesabilitado;
		}

		get Logo() {
			return this._themeConfigs.Logo;
		}

		get CorPrimaria() {
			return this._themeConfigs.CorPrimaria;
		}

		get CorSecundaria() {
			return this._themeConfigs.CorSecundaria;
		}

		isOpenBank() {
			return (this._themeConfigs && this._themeConfigs.isOpenBank) ? true : false;
		}

		/**
		* Fetches theme from API
		*/
		fetchThemeConfigs(carregaImagens: boolean): Observable<any> {
			const idWhiteLabel = this.getIdWhiteLabel();

			if (!idWhiteLabel) {
				this.setThemeWithDefaultConfigs();
				return Observable.of(this.defaultThemeConfigs);
			}

			this._themeConfigs = this.defaultThemeConfigs;
			const params = new HttpParams().set('carregaImagens', `${carregaImagens}`);

			return this.http.get( endpoints.utils.whiteLabel + idWhiteLabel + '/configs', {params} ).pipe( map((data: any) => {
				if (data.Sucesso && data.Retorno !== null) {
					this._themeConfigs = data.Retorno;
					this._themeConfigs.isOpenBank = false;
					this._themeConfigs.isDefault = false;
					this._themeConfigs.isAttendant = (idWhiteLabel === '9b8619251a19057cff70779273e95aa6') ? true : false;
					this.setFrasesInicio(data.Retorno);
				} else if (data.Sucesso && data.Retorno === null ) {
					this.setThemeWithDefaultConfigs();
				} else {
					this._themeConfigs = this.getThemeConfigs();
				}

				this.setFavicon();
				this.setThemeConfigs(this._themeConfigs);
				this.setCssVariables(this._themeConfigs);
			}));
		}

		private setThemeWithDefaultConfigs(){
			this.setCssVariables(this.defaultThemeConfigs);
			this.setThemeConfigs(this.defaultThemeConfigs);
			this._themeConfigs = this.defaultThemeConfigs;
		}

		/**
		* Set the themeConfigs on localStorage
		* @param themeConfigs
		*/
		private setThemeConfigs(themeConfigs: any ) {
			window.sessionStorage.removeItem('themeConfigs');
			window.sessionStorage.setItem('themeConfigs', JSON.stringify(themeConfigs));
		}

		/**
		* Return an object with the themeConfigs retrieved from localStorage
		*/
		public getThemeConfigs(): any {
			let themeConfigs = window.sessionStorage.getItem('themeConfigs');
			themeConfigs = JSON.parse(themeConfigs);

			return themeConfigs;

		}

		public isAttendant() {
			const themeConfigsSession = window.sessionStorage.getItem('themeConfigs');
			let theme = {};
			if (themeConfigsSession === null) {
				theme = this.defaultThemeConfigs;
			} else {
				theme = JSON.parse(themeConfigsSession);
			}
			return theme ? theme['isAttendant'] : false;
		}

		isIE() {
				const ua = navigator.userAgent;
				/* MSIE used to detect old browsers and Trident used to newer ones*/
				const is_ie = ua.indexOf('MSIE') > -1 || ua.indexOf('Trident/') > -1;
				return is_ie;
			}

		setCssVariables = (themeConfigs) => {

			let css = '.primaryColor {color:' + themeConfigs.CorPrimaria + ';}';
			css += '.secondaryColor {color:' + themeConfigs.CorSecundaria + ';}';

			if(themeConfigs.isDefault) {
				css += '.logo {background-image: url(\'/assets/nova_logo_omni.svg\') !important;}';
				css += '[data-component=\'autentication\'] {background-image: url(\'/assets/imgs/login/bg.jpg\');}';
			} else {
				css += '.logo {background-image: url(\'data:image/png;base64,' + themeConfigs.Logo + '\');}';
				if(this.isAttendant()) {
					css += '[data-component=\'autentication\'] {background-color: #013188 ;}';
					css += '[data-component=\'autentication\'] .sliders{ display:none;}';
					css += '[data-component=\'channels-and-fees\'] { display:none;}';
					css += '[data-component=\'login\'] {right: 30% !important;  top: 0 !important;}';
				}  else {
					css += '[data-component=\'autentication\'] {background-image: url(\'data:image/png;base64,'
					+ themeConfigs.Imagens.filter(x => x.TipoImagem === "planoFundo")[0].ConteudoImagem + '\');}';
				}
			}

			css += '.item-menu.active .item {background-color:' + themeConfigs.CorPrimaria + ';}';
			css += '.sidebar .list-menu > .item-menu .list-submenu > .item-submenu > .item .animationLayer {background-color: white;}';
			css += 'a.block:hover {background-color:' + themeConfigs.CorPrimaria + ';}';
			css += '[data-component=\'header\'] .holder .left-content .menu-mobile span {background-color:' + themeConfigs.CorPrimaria + ';}';
			css += '.fillPrimary {fill:' + themeConfigs.CorPrimaria + ';}';
			css += '.strokePrimary {stroke:' + themeConfigs.CorPrimaria + ';}';
			css += '.fillSecondary {fill:' + themeConfigs.CorSecundaria + ';}';
			css += '.ct-series-a .ct-line {stroke:' + themeConfigs.CorPrimaria + '!important;}';
			css += '.ct-series-a .ct-point {stroke:' + themeConfigs.CorPrimaria + '!important;}';
			css += '.btnSecondary {color:' + themeConfigs.CorSecundaria + ';}';
			css += '.mat-raised-button.mat-primary {background-color:' + themeConfigs.CorSecundaria + '; color:' + themeConfigs.CorTextoBotao + ';}';
			css += '.mat-raised-button.mat-primary[disabled] {background-color:' + themeConfigs.CorBotaoDesabilitado +
			'; color:' + themeConfigs.CorTextoBotaoDesabilitado + ';}';
			css += '.btn.border {background-color: transparent; color:' + themeConfigs.CorSecundaria + ';' +
			'border: 1px solid ' + themeConfigs.CorSecundaria + ';}';
			css += '.btn.border:hover {background-color:' + themeConfigs.CorSecundaria + ';}';
			css += '.btn:hover {background-color:' + themeConfigs.CorPrimaria + ';}';
			css += '.material-icons.lock {color:' + themeConfigs.CorPrimaria + ' !important' + ';}';
			css += '[data-component=\'recent-releases\'] .btn-container .btn.border {background-color:' + themeConfigs.CorPrimaria + ';}';
			css += '.drop-table .td.-situation-3 {color:' + themeConfigs.CorSecundaria + ' !important' + ';}';
			css += '.drop-table.-last-transactions .td.-td7 i {color:' + themeConfigs.CorSecundaria + ' !important' + ';}';
			css += '.mat-radio-button.mat-accent .mat-radio-inner-circle {background-color:' + themeConfigs.CorPrimaria + ';}';
			css += '.mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle {border-color:' + themeConfigs.CorPrimaria + ';}';
			css += '.mat-radio-button.mat-accent.mat-radio-checked .mat-radio-label .mat-radio-label-content {color:'
			+ themeConfigs.CorPrimaria + ' !important' + ';}';
			css += '.datepicker-holder .datepicker-calendar {color:' + themeConfigs.CorPrimaria + ';}';
			css += 'h2 {color:' + themeConfigs.CorPrimaria + ';}';
			css += '.filter-holder .filter-item.active {background:' + themeConfigs.CorPrimaria + ';}';
			css += '.filter-holder .filter-item:hover {background:' + themeConfigs.CorPrimaria + ';}';
			css += '.slider .slick-slide .month {color:' + themeConfigs.CorPrimaria + ';}';
			css += '.slider .slick-slide .month:hover {color:' + themeConfigs.CorPrimaria + ';}';
			css += '.filter-holder .filter-item .btn-filter .description {color:' + themeConfigs.CorPrimaria + ';}';
			css += '.slider .btn-filter-month .slick-slide .month {color:' + themeConfigs.CorPrimaria + ';}';
			css += '.slider .btn-filter-month .slick-slide .year {color:' + themeConfigs.CorPrimaria + ';}';
			css += '.slider .btn-filter-month.active {background-color:' + themeConfigs.CorPrimaria + ' !important' + ';}';
			css += '.slider .btn-filter-month:hover {background-color:' + themeConfigs.CorPrimaria + ' !important' + ';}';
			css += '.buttons-holder .button-item .btn-export .icon {color:' + themeConfigs.CorSecundaria + ' !important' + ';}';
			css += '.title-question strong {color:' + themeConfigs.CorPrimaria + ' !important' + ';}';
			css += '.invest-list li {color:' + themeConfigs.CorPrimaria + ' !important' + ';}';
			css += '.title-question strong {color:' + themeConfigs.CorPrimaria + ' !important' + ';}';
			css += '.time-label {border: 1px solid ' + themeConfigs.CorPrimaria + ' !important' + ';}';
			css += '.time-label {color: ' + themeConfigs.CorPrimaria + ';}';
			css += '.time-label:hover {background-color: ' + themeConfigs.CorPrimaria + ';}';
			css += '.slider .slick-arrow {color: ' + themeConfigs.CorPrimaria + ';}';
			css += '.sidebar .list-menu > .item-menu .list-submenu > .item-submenu > .item.active .item-page {color: ' +
			themeConfigs.CorSecundaria + ';}';
			css += '.time-option:checked + .time-label {background-color: ' + themeConfigs.CorPrimaria + ';}';
			css += '.sidebar .list-menu > .item-menu > .item .animationLayer {background-color: ' + themeConfigs.CorPrimaria + ';}';
			css += '.mat-progress-spinner circle {stroke: ' + themeConfigs.CorPrimaria + ' !important' + ';}';
			css += '.mat-checkbox-checkmark-path {stroke: ' + themeConfigs.CorSecundaria + ' !important' + ';}';
			css += '.data-user .name {color: ' + themeConfigs.CorPrimaria + ' !important' + ';}';
			css += '.data-user .account-number {color: ' + themeConfigs.CorPrimaria + ' !important' + ';}';
			css += '[data-component=\"month-filter\"] .slider .slick-arrow:hover {background-color: ' +
			themeConfigs.CorPrimaria + ' !important' + ';}';
			css += '[data-component=\'security-check\'] .material-icons {color: ' + themeConfigs.CorPrimaria + ';}';
			css += '[data-component=\'security-check-registration\'] .material-icons {color: ' + themeConfigs.CorPrimaria + ';}';
			css += '[data-component=\'auth-message\'] .material-icons {color: ' + themeConfigs.CorPrimaria + ';}';
			css += '[data-component=\'define-password\'] .material-icons {color: ' + themeConfigs.CorPrimaria + ';}';
			css += '[data-component=\'redefine-password\'] .material-icons {color: ' + themeConfigs.CorPrimaria + ';}';
			css += '[data-component=\'sms-validation\'] .material-icons {color: ' + themeConfigs.CorPrimaria + ';}';
			css += '[data-component=\'define-subscribe\'] .material-icons {color: ' + themeConfigs.CorPrimaria + ';}';
			css += '.material-icons {color: ' + themeConfigs.CorSecundaria + ';}';
			css += '.btn {background: ' + themeConfigs.CorSecundaria + ';}';
			css += '.box {background: white !important;}';
			css += '.block.-chart {background: white !important;}';
			css += '.application-chart .ct-series-b .ct-slice-donut-solid {fill:' + themeConfigs.CorPrimaria + ' !important;}';
			css += '[data-component=\'investments-extract-details\'] .details-table tr:last-of-type td:last-of-typed {color:' +
			themeConfigs.CorPrimaria + ' !important;}';
			css += '[data-component=\'history-movement\'] .box .header .number {color:' + themeConfigs.CorPrimaria + ' !important;}';
			css += '.mat-progress-bar-fill::after {background-color:' + themeConfigs.CorPrimaria + ' !important;}';
			css += '.calendar svg g {fill:' + themeConfigs.CorPrimaria + ' !important;}';
			css += '.first {fill:' + themeConfigs.CorPrimaria + ' !important;}';
			css += '.b {fill:' + themeConfigs.CorPrimaria + ' !important;}';
			css += '.a {fill:' + themeConfigs.CorPrimaria + ' !important;}';
			css += '[data-component=\"special-filter\"] .filter-holder .filter-item:hover .a {fill: white !important;}';
			css += '[data-component=\"special-filter\"] .filter-holder .filter-item:hover .b {fill: white !important;}';
			css += '[data-component=\"special-filter\"] .filter-holder .filter-item:hover .first {fill: white !important;}';
			css += '[data-component=\"special-filter\"] .filter-holder .filter-item.active .a {fill: white !important;}';
			css += '[data-component=\"special-filter\"] .filter-holder .filter-item.active .b {fill: white !important;}';
			css += '[data-component=\"special-filter\"] .filter-holder .filter-item.active .first {fill: white !important;}';
			css += '[data-component=\'header\'] .holder .right-content .btn-logout > i {color:' + themeConfigs.CorPrimaria + '!important;}';
			css += '[data-component=\'autentication\'] .modal-channels,.modal-channels-new-year {background:' + themeConfigs.CorPrimaria + '!important;}';

			if (this.isIE()) {
				$(document).ready(function() {
					$('style').append(css);
				});
			} else {
				$(document).ready(function() {
					$('style').each(function(i) {
						if (i === 0) {
							$(this).append(css);
						}
					});
				});
		}

	}

	shadeColor = (color, percent) => {
		const f = parseInt(color.slice(1), 16), t = percent < 0 ? 0 : 255, p = percent < 0 ? percent *- 1 : percent,
		R = f>>16, G = f>>8&0x00FF,B=f&0x0000FF;
		return "#"+(0x1000000+(Math.round((t-R)*p)+R)*0x10000+(Math.round((t-G)*p)+G)*0x100+(Math.round((t-B)*p)+B)).toString(16).slice(1);
	}

	setFavicon = () => {
		const docHead = document.getElementsByTagName('head')[0];
		const oldLink = document.querySelector("link[rel*='icon']");
		docHead.removeChild(oldLink);

		let link = document.createElement('link');
		link.type = 'image/x-icon';
		link.rel = 'shortcut icon';

		if (this.getIdWhiteLabel()) {
			const favicon = this._themeConfigs.Imagens.find(i => i.TipoImagem === 'favicon').ConteudoImagem;
			link.href = 'data:image/png;base64,' + favicon;
		} else {
			link.href = '/assets/imgs/favicon.png';
		}
		docHead.appendChild(link);
	}

	setTitle = () => {
		document.title = this._themeConfigs.NomeParceiro;
	}

	setFrasesInicio = (themeConfigs) => {
		$('#fraseInicial1').html(`<div class="text" style="color:${themeConfigs.CorFrase1};"> ${themeConfigs.FraseInicial1} </div>`);
		$('#fraseInicial2').html(`<div class="text" style="color:${themeConfigs.CorFrase2};"> ${themeConfigs.FraseInicial2} </div>`);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/theme-service/theme.service.ts